import "formdata-polyfill";
import "promise-polyfill/src/polyfill";

import {FallcoClass} from "../../../classes/FallcoClass.js";
import FallcoConsole from "../../fallco_console";

import {merge as _merge} from "lodash";
import Utilities from "../../utilities";
import FallcoNotify from "../../notify";
import AjaxDownloader from "./ajaxDownloader";

/**
 * @typedef Ajax.AjaxParams
 * @property {string} action
 * @property {string} url
 * @property {string} method
 * @property {{}} data
 * @property {boolean} remove_empty_fields
 * @property {boolean} removeEmptyFields
 * @property {boolean} returnPromise - @default false - Ritorna una Promise al posto delle callback
 * @property {number} timeout
 * @property {boolean} iframe
 * @property {*} form
 * @property {boolean} show_loading_frame
 * @property {boolean} showLoadingFrame
 *
 * @property {{}} messages
 * @property {string} messages.success
 * @property {string} messages.error
 * @property {string} messages.timeout
 * @property {"all" | "success" | "error"} messages.suppress
 * @property {boolean} fileBase64 - @default false -  Conversione in base64 dei file
 *
 * @property {{}}titles
 * @property {strings} titles.success
 * @property {strings} titles.error
 *
 * @property {{}} ajaxParams
 *
 * @property {function} on_progress_upload
 * @property {function} onProgressUpload
 *
 * @property {function} on_progress_download
 * @property {function} onProgressDownload
 *
 * @property {function} onSuccess
 * @property {function} onError
 */

/**
 * @typedef {Object} Ajax.JSONResponse
 * @property {"ok" | "ko"} esito
 * @property {string} message
 */

class Ajax extends FallcoClass {
  constructor() {
    super("ajax");

    /**
     *
     * @type {Ajax.AjaxParams}
     * @private
     */
    this._defaultParams = {
      action: "",
      url: window.location.toString(),
      method: "",
      data: {},
      removeEmptyFields: false,
      timeout: 30000,
      fileBase64:false,
      iframe: false,
      form: null,
      showLoadingFrame: true,
      global: true,
      returnPromise: false,
      messages: {
        success: "",
        error: "",
        timeout:
            "Stiamo riscontrando dei problemi di comunicazione con il server. Vi invitiamo a riprovare.",
        suppress: "",
      },
      titles: {
        success: null,
        error: null,
      },
      ajaxParams: {},
      onProgressUpload: null,
      onProgressDownload: null,
      onSuccess: null,
      onError: null,
    };

    this.downloadFile = function (...attrs) {
      AjaxDownloader.downloadFile(...attrs);
    };
    /**
     * @deprecated
     * @see downloadFile
     */
    this.download_file = this.downloadFile;

    this.enable_ajax_submit = function (
        form,
        success_callback = null,
        error_callback = null
    ) {
      this.enableAjaxSubmit(form, success_callback, error_callback);
    };

    return super.expose_to_public("ajax", this);
  }

  /**
   * Permette di mutare il submit classico di un form in un post ajax.
   * Necessita come parametro l'elemento Html del form.
   * Può essere passata una callback per il success e per l'error.
   * Inoltre possiede una callback di default, con operazioni standard, in caso di success
   * @method enableAjaxSubmit
   * @param form
   * @param success_callback
   * @param error_callback
   * @example fallco.ajax.enable_ajax_submit(document.querySelector('form'));
   */
  enableAjaxSubmit(form, success_callback = null, error_callback = null) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      //setto modificato a false per evitare l'alert al submit del form.
      window.modificato = false
      this.post(
          {
            url: form.getAttribute("data-url"),
            action: form.getAttribute("data-action"),
            data: new FormData(form),
          },
          (response) => {
            if (!success_callback) this._defaultCallback(response);
            if (success_callback) success_callback(response);
          },
          (response) => {
            if (error_callback) error_callback(response);
          }
      );
    });
  }

  /**
   * Definisce azioni standardizzate al success della chiamata ajax del submit form.
   * Se nella response vi è redirect_to, effettua un redirect all'url specificato
   * @method _defaultCallback
   * @param response
   * @private
   */
  _defaultCallback(response) {
    if (response && response["redirect_to"] !== undefined) {
      window.location.href = response.redirect_to;
    }
  }

  _checkDeprecatedProps(params) {
    // Sostituisco il parametro deprecato con quello nuovo
    if (params.remove_empty_fields) {
      params.removeEmptyFields = params.remove_empty_fields;
      delete params.remove_empty_fields;
    }

    // Sostituisco il parametro deprecato con quello nuovo
    if (params.show_loading_frame) {
      params.showLoadingFrame = params.show_loading_frame;
      delete params.show_loading_frame;
    }

    // Sostituisco il parametro deprecato con quello nuovo
    if (params.on_progress_upload) {
      params.onProgressUpload = params.on_progress_upload;
      delete params.show_loading_frame;
    }

    // Sostituisco il parametro deprecato con quello nuovo
    /*if (params.on_progress_upload) {
      params.onProgressUpload = params.on_progress_upload;
      delete params.show_loading_frame;
    }*/

    return params;
  }
  /**
   *
   * @param {Ajax.AjaxParams} params
   * @returns {Ajax.AjaxParams}
   * @private
   */
  async _prepareParamsFileBase64(params) {
    params = this._checkDeprecatedProps(params);

    if (params.form) {
      params.form = Utilities.get_js_target(params.form, false);

      if (window.FormData) {
        params.data = new FormData(params.form);
      }
    }
    // Controlla chiave e valore nel formData
    // se è presente un tipo di input '[object File]' prende il nome l'inputName e lo passa alla funzione

    for (const pair of params.data.entries()) {
      let inputName = `${pair[0]}`;
      let inputType = `${pair[1]}`;
      if (inputType === '[object File]') {
        let inputFile = params.data.get(inputName);
        let objDataFile = {
          name:inputFile.name,
          lastModified:inputFile.lastModified,
          lastModifiedDate:inputFile.lastModifiedDate,
          size:inputFile.size,
          type:inputFile.type
        }
        let base64 = await this._convertBase64(inputFile);
        if (base64) {
          objDataFile.file = encodeURIComponent(base64);
          params.data.set(inputName, JSON.stringify(objDataFile));
        }
      }
    }
    // Setto il parametro data, assicurandomi che è un oggetto.
    params.data = Utilities.convertDataToObject(params.data);

    if (!params.ajaxParams) {
      params.ajaxParams = {};
    }

    // Se richiesto, rimuovo i campi il cui valore è vuoto
    if (params.removeEmptyFields) {
      params.data = Utilities.removeEmptyParams(params.data);
    }

    if (
        window.FormData !== undefined &&
        params.data instanceof window.FormData
    ) {
      if (!params.data.get("action") && params.action) {
        params.data.append("action", params.action);
      }

      params.ajaxParams.processData = false;
      params.ajaxParams.contentType = false;
    } else {
      if (!params.data.action && params.action) {
        params.data.action = params.action;
      }
    }

    /*
     In caso si showLoadingFrame settato a false, aggiunge il parametro "ajax_loading" = false.
     Questo viene usato dalla libreria "jquery.helperAjax".
     */
    if (params.showLoadingFrame === false) {
      params.ajaxParams.ajax_loading = false;
    }

    if (params.onProgressUpload || params.onProgressUpload) {
      params.ajaxParams.xhr = () => {
        const xhr = new window.XMLHttpRequest();

        //Upload progress
        xhr.upload.addEventListener(
            "progress",
            (evt) => this._onXHRProgress(evt, params),
            false
        );

        return xhr;
      };
    }

    if (params.crossDomain && typeof params.crossDomain === "boolean") {
      params.ajaxParams.crossDomain = params.crossDomain;
    }

    if (params.async !== undefined) {
      if (params.async === false && typeof params.async === "boolean") {
        params.ajaxParams.async = params.async;
      }
    }

    return _merge({}, this._defaultParams, params);
  }

  _convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
        console.warn(error);
      };
    });
  };

  /**
   *
   * @param {Ajax.AjaxParams} params
   * @returns {Ajax.AjaxParams}
   * @private
   */
  _prepareParams(params) {
    params = this._checkDeprecatedProps(params);

    if (params.form) {
      params.form = Utilities.get_js_target(params.form, false);

      if (window.FormData) {
        params.data = new FormData(params.form);
      }
    }

    // Setto il parametro data, assicurandomi che è un oggetto.
    params.data = Utilities.convertDataToObject(params.data);

    if (!params.ajaxParams) {
      params.ajaxParams = {};
    }

    // Se richiesto, rimuovo i campi il cui valore è vuoto
    if (params.removeEmptyFields) {
      params.data = Utilities.removeEmptyParams(params.data);
    }

    if (
        window.FormData !== undefined &&
        params.data instanceof window.FormData
    ) {
      if (!params.data.get("action") && params.action) {
        params.data.append("action", params.action);
      }

      params.ajaxParams.processData = false;
      params.ajaxParams.contentType = false;
    } else {
      if (!params.data.action && params.action) {
        params.data.action = params.action;
      }
    }

    /*
     In caso si showLoadingFrame settato a false, aggiunge il parametro "ajax_loading" = false.
     Questo viene usato dalla libreria "jquery.helperAjax".
     */
    if (params.showLoadingFrame === false) {
      params.ajaxParams.ajax_loading = false;
    }

    if (params.onProgressUpload || params.onProgressUpload) {
      params.ajaxParams.xhr = () => {
        const xhr = new window.XMLHttpRequest();

        //Upload progress
        xhr.upload.addEventListener(
            "progress",
            (evt) => this._onXHRProgress(evt, params),
            false
        );

        return xhr;
      };
    }

    if (params.crossDomain && typeof params.crossDomain === "boolean") {
      params.ajaxParams.crossDomain = params.crossDomain;
    }

    if (params.async !== undefined) {
      if (params.async === false && typeof params.async === "boolean") {
        params.ajaxParams.async = params.async;
      }
    }

    return _merge({}, this._defaultParams, params);
  }

  /**
   * @param {Ajax.AjaxParams} _params
   * @returns {*}
   * @private
   */
  _makeCall(_params) {
    let params;

    if(_params.fileBase64 === true) {
      params = Promise.resolve(this._prepareParamsFileBase64(_params));
      params.then((value) => {
        params = value;

        if (params.form && !window.FormData) {
          return this._postInIframe(...arguments);
        }

        return new Promise((resolve, reject) => {
          const ajaxParams = _merge({}, params.ajaxParams, {
            url: params.url,
            data: params.data,
            // In caso di errore propaga gli eventi fino al window.
            global: params.global,
            type: params.method,
            timeout: params.timeout,
            fromFallcoFrontendFramework: true,
            success: (resp) => this._onAjaxSuccess(resp, params),
            error: (error) => this._onAjaxError(error, params),
          });

          params.onSuccessPromise = (...attrs) => {
            params.onSuccess && params.onSuccess(...attrs);

            params.returnPromise && resolve(...attrs);
          };

          params.onErrorPromise = (...attrs) => {
            params.onError && params.onError(...attrs);

            params.returnPromise && reject(...attrs);
          };

          // Cerca di mostrare il Loading Frame
          params.showLoadingFrame && this._showLoadingFrame();

          $.ajax(ajaxParams);
        });

      })
    } else {
      params = this._prepareParams(_params);
      if (params.form && !window.FormData) {
        return this._postInIframe(...arguments);
      }

      return new Promise((resolve, reject) => {
        const ajaxParams = _merge({}, params.ajaxParams, {
          url: params.url,
          data: params.data,
          // In caso di errore propaga gli eventi fino al window.
          global: params.global,
          type: params.method,
          timeout: params.timeout,
          fromFallcoFrontendFramework: true,
          success: (resp) => this._onAjaxSuccess(resp, params),
          error: (error) => this._onAjaxError(error, params),
        });

        params.onSuccessPromise = (...attrs) => {
          params.onSuccess && params.onSuccess(...attrs);

          params.returnPromise && resolve(...attrs);
        };

        params.onErrorPromise = (...attrs) => {
          params.onError && params.onError(...attrs);

          params.returnPromise && reject(...attrs);
        };

        // Cerca di mostrare il Loading Frame
        params.showLoadingFrame && this._showLoadingFrame();

        $.ajax(ajaxParams);
      });
    }
  }

  _postInIframe(params, successCallback, errorCallback) {}

  /**
   *
   * @param {Ajax.JSONResponse} resp
   * @param {Ajax.AjaxParams} params
   * @private
   */
  _onAjaxSuccess(resp, params) {
    let jsonResp = Utilities.tryJsonParse(resp);

    if (jsonResp && jsonResp.esito === "ok") {
      const serverMessage = resp["message"] || "";

      // Nasconde il LoadingFrame
      params.showLoadingFrame && this._hideLoadingFrame();

      this._showMessages("success", params, serverMessage);
      super.trigger_custom_event({
        target: document,
        name: "ajax_success",
        data: {
          success: resp,
        },
      });

      params.onSuccessPromise && params.onSuccessPromise(jsonResp);
    } else {
      this._onAjaxError(jsonResp, params);
    }
  }

  /**
   *
   * @param {Error|*} error
   * @param {Ajax.AjaxParams} params
   * @private
   */
  _onAjaxError(error, params) {
    // Se l'errore avviene perchè la chiamata va in timeout, crea un parametro boolenao nel response
    // Setta inoltre un messaggio di default.
    if (error && error.statusText === "timeout") {
      error.timeout = true;
      error.message = params.messages.timeout;
    }

    //Prova a prendersi l'error code dall'HTML, se viene ritornato un HTML
    let errorCode = ''
    if(error && error.responseText && !Utilities.tryJsonParse(error.responseText)){
      const parser = new DOMParser();
      const doc = parser.parseFromString(error.responseText, 'text/html')
      errorCode = doc.getElementById('rayId')?.innerText || ''
      if(errorCode){
        errorCode = ` (${errorCode})`
      }
    }

    let serverMessage = "Si è verificato un errore: "

    let errorDetail = error ?
        (error["responseJSON"] ? error["responseJSON"].message : "") ||
        error["message"] ||
        (
            error.status === 403 ?
                'Accesso non consentito' :
                error.status === 404 ?
                    'Pagina non trovata' :
                    "Errore nell'esecuzione della chiamata"
        ) :
        "Errore nell'esecuzione della chiamata";

    serverMessage += errorDetail + errorCode;

    FallcoConsole.warn(
        `AJAX - ${
            error && error.statusText === "timeout"
                ? "TIMEOUT"
                : "Errore nell'esecuzione"
        } della chiamata: `,
        error
    );

    // Nasconde il LoadingFrame
    params.showLoadingFrame && this._hideLoadingFrame();

    if(!error || error.status === 403 || error.status === 404){
      params.messages = {}
    }
    this._showMessages("error", params, serverMessage);
    super.trigger_custom_event({
      target: document,
      name: "ajax_error",
      data: {
        error: error ? error : params.messages,
      },
    });

    params.onErrorPromise &&
    params.onErrorPromise(error.responseJSON ? error.responseJSON : error);
  }

  /**
   * @param evt
   * @param {Ajax.AjaxParams} params
   * @private
   */
  _onXHRProgress(evt, params) {
    if (evt.lengthComputable) {
      evt.percent_complete = (evt.loaded / evt.total) * 100;

      params.onProgressUpload && params.onProgressUpload(evt);
    }
  }

  /**
   *
   * @param {string} type
   * @param {Ajax.AjaxParams} params
   * @param {string} serverMessage
   * @private
   */
  _showMessages(type, params, serverMessage = "") {
    let message = params.messages[type] || "";
    let title = params.titles[type] || "";
    let notifyObject = {
      title,
      message,
      extra_message: serverMessage,
    };

    if (
        params.messages.suppress === "all" ||
        params.messages.suppress === type
    ) {
      return;
    }

    if (FallcoNotify) {
      switch (type) {
        case "success":
          FallcoNotify.success(notifyObject);
          break;
        case "error":
          FallcoNotify.error(notifyObject);
          break;
      }
    }
  }

  _showLoadingFrame() {
    if ($.helper && $.helper.loading_frame) {
      $.helper.loading_frame.show(parent);
    }
  }

  _hideLoadingFrame() {
    if ($.helper) {
      for (let i = 0; i <= $.helper.loading_frame.self.counter; i++) {
        $.helper.loading_frame.hide();
      }
    }
  }

  // METODI PUBBLICI

  /**
   * @param {Ajax.AjaxParams} params
   * @param {function} successCallback
   * @param {function} [errorCallback]
   */
  get(params, successCallback, errorCallback) {
    params.method = "GET";
    params.onSuccess = successCallback;
    params.onError = errorCallback;

    return this._makeCall(params);
  }

  /**
   * @param {Ajax.AjaxParams} params
   * @param {function} [successCallback]
   * @param {function} [errorCallback]
   */
  post(params, successCallback, errorCallback) {
    params.method = "POST";
    params.onSuccess = successCallback;
    params.onError = errorCallback;

    return this._makeCall(params);
  }
}

export default new Ajax();
